const PROSPECTING_TAG_DESCRIPTIONS = {
  "Potential Prospect":
    "Visited site, property, expansion, or incentive pages in ways that suggest early-stage project interest.",
  "Customer / Existing Employer":
    "An existing employer or local company showing repeat engagement from within your region.",
  "High Intent":
    "Strong behavioral signals such as repeat visits, longer time on site, target-industry alignment, or intent-page activity.",
  "Low Intent":
    "Some engagement is present, but the signals do not yet suggest active project evaluation.",
  "Existing Employer":
    "A company already located in your community or region.",
  Stakeholder:
    "A partner, institution, or organization that influences economic development outcomes.",
  "Investor / Developer":
    "A group or individual associated with development, capital investment, or real estate activity.",
  "Site Selector / Consultant":
    "A consultant or advisory group representing companies evaluating locations.",
  "Other EDO / Municipality":
    "Another public-sector or economic development organization contact.",
  "Media / Researcher":
    "A journalist, analyst, or researcher gathering information rather than pursuing a project.",
  "High Priority":
    "A prospect your team wants to actively monitor or engage because of strategic importance or urgency.",
  "Target Industry":
    "A company aligned with one of your organization’s strategic target industries.",
  "Follow-Up":
    "A prospect that needs another touchpoint, response, or next-step action from staff.",
  Prospect:
    "Legacy tag for a company identified as a prospect. Kept for existing records.",
  "Lead – High Intent":
    "Legacy label for a high-intent automated signal. Equivalent to High Intent.",
  "Lead – Low Intent":
    "Legacy label for a lower-intent automated signal. Equivalent to Low Intent.",
};

export function getProspectingTagDescription(tag) {
  return PROSPECTING_TAG_DESCRIPTIONS[String(tag || "").trim()] || "";
}
